// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"54565a11","496":"4c8f0822"}[chunkId] + ".chunk.js";
};